import React from 'react'

export default function Icon({ src, alt, style, width, height }) {
  return <img
    src={src}
    alt={alt || 'error loading'}
    style={style || {
      width: width || height || '2rem',
      height: height || ''
    }}
  />
}